import { Controller, useFormContext } from "react-hook-form";
import { InputBaseParams } from "../Form";

const TextBoxV2 = ({
  name,
  placeholder,
  password,
  rules,
  className,
  errorClassName,
  onFocus,
  onBlur
}: InputBaseParams & {
  password?: boolean;
  placeholder?: string;
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <input
            {...field}
            onFocus={onFocus}
            onBlur={() => {
              if (onBlur) onBlur();
              field.onBlur();
            }}
            type={password ? "password" : "text"}
            placeholder={placeholder}
            className={`${className} ${error && errorClassName}`}
          />
        </>
      )}
    />
  );
};

export default TextBoxV2;
